import React from 'react';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Modal from '../../../../../components/Modal';
import InfoForm from '../../../../../components/outline/InfoForm';
import { MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT } from '../../../../../constants/service/app/tagConstants';
import './EditTagTabMainModal.scss';

const EditTagTabMainModal = (props) => {
  const { form, isOpen, closeModal, memo, onSubmit, setData } = props;

  return (
    <Modal
      title="태그 탭 메인 편집하기"
      isOpen={isOpen}
      width={560}
      height={300}
      isFooter={true}
      okText="저장"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <InfoForm className="edit-tag-tab-main-modal-wrap">
        {/*트랜드 키워드 리스트 메모*/}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT} />
            </span>
          }
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT}
          onChange={(value) =>
            setData({
              name: 'memo',
              value,
            })
          }
          initialValue={memo}
          subContent={'* 트렌드 키워드 리스트 저장 시 남길 메모를 입력해주세요.'}
          name="memo"
          autoSize={{ minRows: 6, maxRows: 50 }}
        />
      </InfoForm>
    </Modal>
  );
};

export default EditTagTabMainModal;
